import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxCalculatorresultskey } from './Calculatorresultskey'
import { CalculatorresultskeyProps } from './Calculatorresultskey'

interface CalculatorresultskeyBlokProps {
  blok: {
    title: CalculatorresultskeyProps['title']
    subtitle: CalculatorresultskeyProps['subtitle']
    keys: SbBlokData[]
  } & SbBlokData
}

const Calculatorresultskey: FC<CalculatorresultskeyBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxCalculatorresultskey
        title={blok.title}
        subtitle={blok.subtitle}
        keys={
          blok.keys &&
          blok.keys.map((nestedBlok: SbBlokData, index: any) => (
            <StoryblokServerComponent key={nestedBlok.id || index} blok={nestedBlok} />
          ))
        }
      />
    </div>
  )
}

export default Calculatorresultskey
